export const isLocal = window.location.hostname === "localhost";
export const API_HOST = isLocal
  ? `http://127.0.0.1:8001/api`
  : `${window.location.origin}/server/api`;

export const AUTH0_AUDIENCE = isLocal
  ? "http://127.0.0.1:8001"
  : window.location.origin;
